import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-paper px-5 text-center">
      <div aria-hidden="true" className="bg-grid mask-fade-top pointer-events-none absolute inset-0" />
      <div className="relative">
        <Logo className="mx-auto h-[26px] w-auto" />
        <p className="mt-12 font-mono text-[12px] uppercase tracking-[0.16em] text-brand-700">Erro 404</p>
        <h1 className="mt-4 text-[34px] font-semibold tracking-[-0.035em] text-ink-900 sm:text-[44px]">Página não encontrada</h1>
        <p className="mt-4 text-lg text-ink-600">O endereço que você acessou não existe ou foi movido.</p>
        <a href="/" className="btn-primary mt-8">
          <ArrowLeft className="h-[18px] w-[18px]" aria-hidden="true" />
          Voltar para o início
        </a>
      </div>
    </div>
  );
};

export default NotFound;
